import _SerialPort from "./serialPortNode";
const APISerialPort = window.__capture__.debug ? _SerialPort : window.require("serialport");
const Delimiter = window.require("@serialport/parser-delimiter");

export default class SerialPort {
  constructor(port) {
    this.port = port;
    this.lstCmd = [];
  }
  open(callback) {
    if (this.device && this.device.isOpen) {
      if (callback && typeof callback === "function") {
        let tmp = true;
        callback(tmp);
      }
    } else {
      this.device = new APISerialPort(this.port, undefined, (err) => {
        if (err) {
          console.log(`open port ${this.port} error:`, err);
        } else {
          let parser = this.device.pipe(new Delimiter({ delimiter: ">" }));
          parser.on("data", (data) => {
            this.recvData(data);
          });
        }
        if (callback && typeof callback === "function") {
          let result = !err;
          callback(result, err);
        }
      });
    }
  }
  regListen(callback) {
    this.listenCallback = callback;
  }
  isOpen() {
    return this.device && this.device.isOpen;
  }
  doWrite() {
    if (this.recvCallback !== null) {
      return;
    }
    if (this.lstCmd.length > 0) {
      let { cmd, callback, timeout } = this.lstCmd.shift();
      this.write(cmd, callback, timeout);
    }
  }
  write(cmd, callback, timeout = 500) {
    if (this.recvCallback) {
      this.lstCmd.push({ cmd, callback, timeout });

      return;
    }

    this.recvCallback = callback;
    this.device.write(cmd);
    this.device.drain(() => {});
    this.waitTimeout = setTimeout(() => {
      if (this.recvCallback) {
        if (typeof this.recvCallback === "function") {
          this.recvCallback("failed");
        }
        this.recvCallback = null;
        this.doWrite();
      }
    }, timeout);
  }
  recvData(data) {
    data = data.toString() + ">";
    // console.log(data)
    if (data.indexOf("<6") >= 0) {
      if (this.listenCallback && typeof this.listenCallback === "function") {
        this.listenCallback(data);
      }
    } else {
      if (this.recvCallback && typeof this.recvCallback === "function") {
        this.recvCallback(data);
      }
      if (this.port === "/dev/ttyS0" && data === "<2>") {
        return;
      }
      this.recvCallback = null;
      if (this.waitTimeout) {
        clearTimeout(this.waitTimeout);
        this.waitTimeout = null;
      }
      this.doWrite();
    }
  }
  close() {
    if (this.device) {
      this.device.close((error) => {
        this.device = null;
        if (error) {
          console.log(`close port ${this.port} error:`, error);
        }
      });
    }
  }
  onError(err) {
    console.log(`port ${this.port} error:`, err);
  }
  getPorts() {
    SerialPort.list().then((ports) => {});
  }
}



// WEBPACK FOOTER //
// ./src/mainInterface/js/SerialPort.js